import { BusinessSubscription } from "lens-platform-sdk";

export const getCurrentSubscription = (subscriptions: Array<BusinessSubscription>) => {
  return subscriptions
    .filter((sub) => sub.state === "active")
    .sort((a, b) => {
      if (!a.currentPeriodStartedAt) {
        return 1;
      }

      if (!b.currentPeriodStartedAt) {
        return -1;
      }

      return new Date(b.currentPeriodStartedAt).getTime() - new Date(a.currentPeriodStartedAt).getTime();
    })[0];
};
